module.exports = __webpack_public_path__ + "static/media/scope_trial.72b558c2.png";